import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "../pages/ForgotPasswordStyles";
import { Field, reduxForm, formValueSelector } from "redux-form";
import ErrorMessage from "../components/ErrorMessage";
import { connect } from "react-redux";

const selector = formValueSelector("forgot-password");

const renderField = (props) => {
  const {
    input,
    label,
    type,
    minLength,
    meta: { touched, error, warning },
  } = props;

  const inputStyles = css([
    styles.input,
    touched && error && styles.inputError,
  ]);
  return (
    <div>
      <input
        {...input}
        placeholder={label}
        type={type}
        className={inputStyles}
        minLength={minLength}
      />
      {touched &&
        ((error && <span className={css(styles.error)}>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  );
};

let ForgotPasswordForm = (props) => {
  const { handleSubmit, pristine, submitting, submitSucceeded, submitFailed } =
    props;

  return (
    <div>
      {!submitSucceeded && (
        <form onSubmit={handleSubmit}>
          <div>
            <p className={css(styles.paragraph)}>
              Please enter your email address to recover your password.
            </p>
            <Field
              name="email"
              component={renderField}
              type="email"
              label="Your email address"
            />
          </div>

          <div>
            <button
              type="submit"
              disabled={pristine || submitting}
              className={css(styles.buttonWhite)}
            >
              Send Recover Password Email
            </button>
          </div>
        </form>
      )}
      {submitSucceeded && (
        <div className={css(styles.successWrapper)}>
          <img
            src={"/icons/check.svg"}
            className={css(styles.checkIcon)}
            alt=""
          />
          <p className={css(styles.successTitle)}>
            If your email is registered on our system, instructions on how to
            reset your password will be sent to{" "}
            <strong>{props.emailValue}</strong>. Please check your email and
            your Junk Mail folder for further instructions.
          </p>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    emailValue: selector(state, "email"),
    password: state.password,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "forgot-password",
  })(ForgotPasswordForm)
);
